import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  AdminMeetingTemplateDto,
  MeetingTemplateCreateInput,
  MeetingTemplateUpdateInput,
} from '@upme/contracts';
import { api } from '../../app/api-client';
import { meetingTemplateByIdOptions, meetingTemplatesKey } from './queries';

export function useCreateMeetingTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: MeetingTemplateCreateInput) =>
      api.post('admin/meeting-templates', { json: body }).json<AdminMeetingTemplateDto>(),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...meetingTemplatesKey] }),
  });
}

export function useUpdateMeetingTemplate(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: MeetingTemplateUpdateInput) =>
      api.patch(`admin/meeting-templates/${id}`, { json: body }).json<AdminMeetingTemplateDto>(),
    onSuccess: (data) => {
      qc.setQueryData(meetingTemplateByIdOptions(id).queryKey, data);
      qc.invalidateQueries({ queryKey: [...meetingTemplatesKey] });
    },
  });
}

export function useDeleteMeetingTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`admin/meeting-templates/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...meetingTemplatesKey] }),
  });
}
